import React, { useState } from 'react';
import { Button, IconButton, Menu, MenuItem, Stack } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import resolveResponsiveToolbarActions from '../../../../helpers/mrt/resolveResponsiveToolbarActions';

export default function ToolbarPocos({ actions, isMobile }) {
    const [anchor, setAnchor] = useState(null);
    const { visibleActions, menuActions } = resolveResponsiveToolbarActions(actions, { isMobile });
    return <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {visibleActions.map(a => <Button key={a.key} title={a.title} color={a.color || 'secondary'} variant={a.variant || 'text'} disabled={a.disabled} onClick={a.onClick}>{a.label}</Button>)}
        {menuActions.length > 0 && <>
            <IconButton title="Mais ações da consulta" aria-label="Mais ações da consulta" onClick={e => setAnchor(e.currentTarget)}><MoreVert /></IconButton>
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
                {menuActions.map(a => <MenuItem key={a.key} title={a.title} disabled={a.disabled} onClick={() => { setAnchor(null); a.onClick(); }}>{a.label}</MenuItem>)}
            </Menu>
        </>}
    </Stack>;
}
